"use client";

import { Card, Button } from "react-bootstrap";

const OutlineRoundedButtons = ({ active, onChange }) => {
  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <div className="d-flex gap-2 flex-wrap">
  <Button
    variant={active === "all" ? "primary" : "outline-primary"}
    className="py-2 px-4 rounded-pill text-nowrap"
    style={{ minWidth: "120px" }}
    onClick={() => onChange("all")}
  >
    All Members
  </Button>

  <Button
    variant={active === "working" ? "success" : "outline-success"}
    className="py-2 px-4 rounded-pill text-nowrap"
    style={{ minWidth: "120px" }}
    onClick={() => onChange("working")}
  >
    Working
  </Button>

  <Button
    variant={active === "meeting" ? "info" : "outline-info"}
    className="py-2 px-4 rounded-pill text-nowrap"
    style={{ minWidth: "120px" }}
    onClick={() => onChange("meeting")}
  >
    Meeting
  </Button>

  <Button
    variant={active === "break" ? "warning" : "outline-warning"}
    className="py-2 px-4 rounded-pill text-nowrap"
    style={{ minWidth: "120px" }}
    onClick={() => onChange("break")}
  >
    Break
  </Button>

  <Button
    variant={active === "not_started" ? "danger" : "outline-danger"}
    className="py-2 px-4 rounded-pill text-nowrap"
    style={{ minWidth: "120px" }}
    onClick={() => onChange("not_started")}
  >
    Yet to Start
  </Button>
</div>
      </Card.Body>
    </Card>
  );
};

export default OutlineRoundedButtons;